export default "__VITE_ASSET__CB5OTDe6__"